module.exports = __webpack_public_path__ + "static/media/customer-harvest.27c590a9.png";